import { type AxiosRequestConfig } from "axios";
import { clientApi } from "~/utils/clientApi";
import { TAXONOMY_PAYMENT_METHOD, EDUCATIONAL_PLATFORM, TAXONOMY_PRODUCT_TYPE, CLIENT_FROM_ORIGINS, TAXONOMY_STEP_FEEDBACK_OPTIONS, SEGMENTS } from "./apiUrls";
import { ClientId } from "~/typings/types";
import { ApiCategory, ApiSegment } from "~/new-ui-customer-questionnaire/components/SegmentField/shared/types";

export const defaultAxiosRequestConfig: DefaultAxiosRequestConfig = {
  retry: 10,
  retryDelay: 10000
};

export type ResSuccess = 1 | 0;

export interface ReqPostData<T> {
  id: ClientId;
  is_presave_mode?: boolean;
  fields: T;
}

export interface ReqPostArguments<T> {
  data: ReqPostData<T>;
  config?: DefaultAxiosRequestConfig;
}

export interface ErrorFieldFromBackend {
  code: "field_validation" | "confirmation:incorrect_code" | "code_confirmation:too_many_attempts";
  message: string;
  data: {
    target_type: string;
    target: string;
  };
}

export interface ResPost {
  success: ResSuccess;
  errors?: ErrorFieldFromBackend[];
}

export interface DefaultAxiosRequestConfig extends AxiosRequestConfig {
  retry?: number;
  retryDelay?: number;
}

interface ApiResponseSharedDataFromBackend {
  success: ResSuccess;
  data: SharedDataFromBackend;
}


export type SharedDataFromBackend = Record<string, { name: string; title: string }>;

export const getPaymentMethod = async (url: string = TAXONOMY_PAYMENT_METHOD): Promise<ApiResponseSharedDataFromBackend> => {
  try {
    const res = await clientApi.get(url);
    if (res?.data?.success === 0) {
      throw new Error("Error from backend, method: getPaymentMethod");
    }
    return res.data;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const getProductType = async (): Promise<ApiResponseSharedDataFromBackend> => {
  try {
    const res = await clientApi.get(TAXONOMY_PRODUCT_TYPE);
    if (res?.data?.success === 0) {
      throw new Error("Error from backend, method: getProductType");
    }
    return res.data;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const getEducationalPlatform = async (): Promise<ApiResponseSharedDataFromBackend> => {
  try {
    const res = await clientApi.get(EDUCATIONAL_PLATFORM);
    if (res?.data?.success === 0) {
      throw new Error("Error from backend, method: getEducationalPlatform");
    }
    return res.data;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const getClientFromOrigins = async (): Promise<ApiResponseSharedDataFromBackend> => {
  try {
    const res = await clientApi.get(CLIENT_FROM_ORIGINS);
    if (res?.data?.success === 0) {
      throw new Error("Error from backend, method: getClientFromOrigins");
    }
    return res.data;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const getStepFeedbackOptions = async (): Promise<ApiResponseSharedDataFromBackend> => {
  try {
    const res = await clientApi.get(TAXONOMY_STEP_FEEDBACK_OPTIONS);
    if (res?.data?.success === 0) {
      throw new Error("Error from backend, method: getStepFeedbackOptions");
    }
    return res.data;
  } catch (err: any) {
    throw new Error(err);
  }
};

export interface SegmentsApiResponse {
  categories: Record<string, ApiCategory>;
  segments: Record<string, ApiSegment>;
}
interface ApiResponseSegmentsApiResponseFromBackend {
  success: ResSuccess;
  data: SegmentsApiResponse;
}

export const getSegments = async (): Promise<ApiResponseSegmentsApiResponseFromBackend> => {
  try {
    const res = await clientApi.get(SEGMENTS);
    if (res?.data?.success === 0) {
      throw new Error("Error from backend, method: getSegments");
    }
    return res.data;
  } catch (err: any) {
    throw new Error(err);
  }
};
